import React from "react"

import { RoomFormModel } from "features/room-management/types/RoomFormModel"

import { NewRoomOverlayView } from "./NewRoomOverlayView"

export interface NewRoomOverlayModel {
  roomFormModel: RoomFormModel
  isLoading?: boolean
  isSubmitting?: boolean
  onCancel: () => void
}

export interface NewRoomOverlayProps extends NewRoomOverlayModel {
  autoFocus?: boolean
  hideProject?: boolean
}

export const NewRoomOverlay = React.memo((props: NewRoomOverlayProps) => (
  <NewRoomOverlayView {...props} formID="new-room-overlay-form" />
))
